<template>
	<div class="card !shadow-none !border-0">
		<QuizStepper orientation="vertical">
			<StepperPanel v-for="( question, index) in questions" :key="index" :active="currentQuestionIndex === index"
			:header="labels.questionLabel + (index + 1)"
			>
			<template #content="{ prevCallback, nextCallback }">
					<div class="flex flex-col">
						<InplaceEdit
							class="!items-start"
							:inputProp="{ content: question, inputType: 'quiz', propName: 'content' }"
							method="PUT"
							:href="question._links?.self.href"
							blockTitle="Edit Question"
							:showAssistant="true"
							>
							<span class="font-semibold">{{ question.question }}</span>
						</InplaceEdit>

						<div class="py-5 flex-auto flex flex-col justify-center items-start font-semibold">
							<div v-for="( answer, aIndex) in question.answers" :key="aIndex"
								class="p-4 w-full bg-gray-100">
								<div class="text-md flex">
									<QuizCheck :value="aIndex" v-model="selectedAnswers[index]"
										:inputId="'answer-' + index + 1 + '-' + aIndex + answer.answer?.length"
										:name="'answer-' + index + 1 + '-' + aIndex + answer.answer?.length" />
									<label :for="'answer-' + index + 1 + '-' + aIndex + answer.answer?.length"
										class="ml-2 font-normal">
										{{ answer.answer }}
									</label>
								</div>
								<div v-if=" selectedAnswers[index].includes( aIndex ) ">
									<div class="flex items-start gap-2 px-3 font-normal py-3 mt-3 border rounded-md border-success/40 bg-success-100/10 text-dark"
										v-if=" answer.isCorrect ">
										<i
											class="tabler:circle-check !text-[35px] text-success max-w-[40px] !w-[40px] max-h-[40px] !h-[40px] min-w-[40px]"></i>
										<span class="text-sm">{{ answer.explanation }} </span>
									</div>
									<div v-else
										class="flex items-start gap-2 px-3 font-normal py-3 mt-3 border rounded-md border-danger/40 bg-danger-100/10 text-dark">
										<i
											class="tabler:circle-x !text-[35px] text-danger max-w-[40px] !w-[40px] max-h-[40px] !h-[40px] min-w-[40px]"></i>

										<span class="text-sm">{{ answer.explanation }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="flex pt-4 justify-between">
						<EwButton v-if=" index " :label="'Back'" type="secondary" :icon="'tabler:arrow-narrow-left'"
							@click="prevCallback" />
						<EwButton v-if=" index < questions.length - 1 " type="success" :label="'Next'"
							:iconAppend="'tabler:arrow-narrow-right'" @click="nextCallback" />
						<EwButton v-if=" questions.length - 1 === index " type="success" :label="'Finish'"
							:iconAppend="'tabler:check'" @click="handleClose" />
					</div>
				</template>
			</StepperPanel>
		</QuizStepper>
	</div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { messages } from '@/assets/language';
import type { LanguageCodes, QuizQuestionsItem } from '@/types'
import InplaceEdit from './InplaceEdit/InplaceEdit.vue';
import { useAppStore } from '@/stores/app-store'


const { currentLng } = useAppStore()
const labels = computed( () => {
	const key = currentLng.value as keyof typeof messages
	return messages[key] ?? {}
});

const props = defineProps<{
  selectedLanguage?: LanguageCodes;
  jsonData: {
    postQuiz: { questions: QuizQuestionsItem[] };
	_links: { postQuiz: { href: string }; postQuizEdit: { href: string } };
  };
}>();

const questions = computed(() => props.jsonData.postQuiz.questions);
const selectedAnswers = ref<Array<Array<number>>>(
  props.jsonData.postQuiz.questions.map(() => [])
);
const currentQuestionIndex = ref( 0 );
const emits = defineEmits( ['close'] );

const handleClose = () => {
	emits( 'close' );
};
</script>

<style scoped>
/* .p-stepper {
	flex-basis: 50rem;
} */
</style>
